export const CASE_TYPE_OPTIONS = [
    "Fraud",
    "Litigation Support",
    "Regulatory",
    "Bankruptcy",
    "Martial dissolution",
    "Business or shareholder dispute",
    "Valuation",
    "Other"
];
  
export const PRIORITY_OPTIONS = ["Low", "Medium", "High"];

export const STATUS_OPTIONS = ["Open", "In Progress", "Closed"];

// Fixed litigation-support case-stage checklist, always reached in this
// order (mirrors the Faros Forensics case tracker workflow).
export const CASE_STAGE_OPTIONS = [
    "Initial interview",
    "Engagement letter",
    "Retainer received",
    "Document request",
    "Case work",
    "Write report",
    "Circulate draft",
    "Sign final report",
    "Trial",
    "Case closed",
];

// Who/what a case is currently blocked on - independent of case_stage
// (a case can be at "Case work" and still be waiting on the client's files).
export const WAITING_ON_OPTIONS = [
    "Client documents",
    "Attorney",
    "Opposing counsel",
    "Court",
    "Payment / retainer",
    "Internal review",
    "Other",
];

export const PAYMENT_METHOD_OPTIONS = ["Check", "ACH", "Wire", "Credit card", "Cash", "Other"];
export const PAYMENT_TYPE_OPTIONS = ["Retainer", "Payment", "Refund"];

// Required Files Feature Constants
export const REQUIRED_FILE_CATEGORIES = [
    "Bank Statements",
    "Company Documents",
    "Financial Records",
    "Legal Documents",
    "Supporting Documents",
    "Other"
] as const;

export const REQUIRED_FILE_TYPES = {
    "Bank Statements": ["bank_statement"],
    "Company Documents": ["company_origination", "bylaws", "operating_agreement"],
    "Financial Records": ["tax_return", "financial_statement", "invoice"],
    "Legal Documents": ["contract", "agreement", "court_filing"],
    "Supporting Documents": ["receipt", "correspondence", "note"],
    "Other": ["general"]
} as const;

// All available file types for upload and requirements (UI display names)
export const FILE_TYPES = [
  'Appraisal',
  'Bank credit (deposit)',
  'Bank debit (withdrawal)',
  'Bank signature card',
  'Bank Statements', // Keep this working version
  'Check Images', // Keep this working version
  'Check register',
  'Correspondence',
  'Credit card statement',
  'Deeds and titles',
  'Deposit image',
  'Depreciation schedule',
  'Email',
  'Expense report',
  'Financial statement - Balance sheet',
  'Financial statement - Income statement',
  'Financial statement - Other',
  'Financial statement - Statement of cash flows',
  'General ledger',
  'Investment account statement',
  'Invoice',
  'IRS Tax form 1040',
  'IRS Tax form 1065',
  'IRS Tax form 1099',
  'IRS Tax form 1120',
  'IRS Tax form 1120S',
  'IRS Tax form 941',
  'IRS Tax form K-1',
  'IRS Tax form Other',
  'IRS Tax form W2',
  'IRS Tax form W4',
  'Lease agreement',
  'Legal document',
  'Loan application',
  'Loan statement',
  'Note payable',
  'Other',
  'Trial balance',
  'Wire transfer',
] as const;

export type RequiredFileCategory = typeof REQUIRED_FILE_CATEGORIES[number];
export type RequiredFileType = typeof REQUIRED_FILE_TYPES[RequiredFileCategory][number];

export interface AuditLogEntry {
    timestamp: string;
    user: string;
    action: string;
    details: string;
}

export interface BankStatementAnalysis {
    statement_id: string;
    case_id: string;
    file_id: string;
    account_number: string;
    bank_name: string;
    statement_date: string;
    total_additions: number;
    total_deductions: number;
    net_change: number;
    beginning_balance?: number;
    ending_balance?: number;
    transactions: Array<{
      transaction_id: string;
      date: string;
      description: string;
      amount: number;
      transaction_type: 'credit' | 'debit';
    }>;
}

export interface ProcessedBankStatement {
    statement_id: string;
    file_id: string;
    bank_name: string;
    account_number: string; // last 4 digits
    statement_date: string;
}

export interface CreateAnalysisRequest {
    case_id: string;
    type: string;
    name: string;
    description?: string;
    inputs: {
      dateRange: {
        from: string;
        to: string;
      };
      includedStatements: string[];
    };
  }
  